/* eslint-disable */
import React, {useState} from "react";
import "antd/dist/antd.min.css";
import {Button, Collapse, Form, InputNumber, Popconfirm, Space, Switch, TimePicker, Typography,} from "antd";
import {useTranslation} from "react-i18next";
import moment from "moment";
import TrendConstraintApprox from "../../components/TrendConstraintApprox";
import localeRU from "antd/es/date-picker/locale/ru_RU";
import localeEN from "antd/es/date-picker/locale/en_GB";
import localeES from "antd/es/date-picker/locale/es_ES";
import {DeleteOutlined} from "@ant-design/icons";
import {useStore} from "../../../../../../../../../../../../hooks/useStore";
import {observer} from "mobx-react-lite";

const TrendSettings = observer(({warningId, warningData}) => {
    const {commonTrendParameterConstraintsStore, accessStore} = useStore();

    const {t} = useTranslation();
    const storageTranslations = JSON.parse(
        sessionStorage.getItem("translations")
    );

    const [buttonText, setButtonText] = useState(t("apply"));

    const chooseTranslateFromArray = (id, array, lang) => {
        const translationIndex =
            array &&
            array[lang] &&
            array[lang].findIndex((x) => x.parameterId === id);
        const parameterIndex =
            array &&
            array?.parameters &&
            array?.parameters.findIndex((x) => x.id === id);

        if (translationIndex >= 0) {
            return array[lang][translationIndex].translation
                ? array[lang][translationIndex].translation
                : array?.parameters[parameterIndex].alias;
        }

        return parameterIndex >= 0 ? array?.parameters[parameterIndex].alias : id;
    };

    const onFinish = async (values) => {
        values.trendSettingsCommon.warningId = warningId;
        await commonTrendParameterConstraintsStore.updateTrendCommonAnalysisSettings(warningData?.trendGroupName, warningData?.trendConstraints, values.trendSettingsCommon)
        setButtonText(t("applied"));
    };

    const {i18n} = useTranslation();
    const currentLanguage = i18n.language;

    let locale = "";

    moment.locale("ru");
    switch (currentLanguage) {
        case "ru": {
            locale = localeRU;
            moment.locale("ru");
            break;
        }
        case "en": {
            locale = localeEN;
            moment.locale("en-gb");
            break;
        }
        case "es": {
            locale = localeES;
            moment.locale("es");
            break;
        }
        default: {
            locale = localeRU;
            moment.locale("ru");
            break;
        }
    }

    const handleDeleteConstraint = async (id, groupId, parameterId) => {
        try {
            await commonTrendParameterConstraintsStore.deleteCommonTrendParameterConstraints(id, groupId, parameterId);
        } catch (error) {
            console.error("Error deleting constraint:", error);
        }
    };

    const {Panel} = Collapse;

    const layout = {
        labelCol: {
            span: 14,
        },
        wrapperCol: {
            span: 12,
        },
    };

    return (
        <Form
            {...layout}
            name="nest-messages"
            onFinish={onFinish}
            className
            onValuesChange={() => setButtonText(t("apply"))}
        >
            <Form.Item initialValue={warningData?.status}
                       name={["trendSettingsCommon", "status"]}
                       valuePropName="checked"
                       label="Трендовые настройки ВКЛ/ВЫКЛ"
                       labelAlign="left"
                       wrapperCol={{
                           offset: 0,
                           span: 16,
                       }}
            >
                <Switch/>
            </Form.Item>
            <Form.Item initialValue={moment.utc(warningData.analysisTime, "HH:mm:ss").local()}
                       labelAlign="left"
                       label={"Время старта анализа"}
                       name={["trendSettingsCommon", "analysisTime"]}
            >
                <TimePicker locale={locale}/>
            </Form.Item>
            <Form.Item
                labelAlign="left"
                label="Отсрочка срабатывания"
                rules={[{required: false, message: "Введите интервал"}]}
            >
                <Form.Item initialValue={warningData?.delayResponse.minute}
                           noStyle
                           name={["trendSettingsCommon", "delayResponseMinutes"]}
                           rules={[{required: false, message: "Введите минуты интервала"}]}
                >
                    <InputNumber
                        min={0}
                        max={999}
                        style={{
                            width: "30%",
                        }}
                    />
                </Form.Item>

                <span className="ant-form-text" style={{paddingLeft: "5px"}}>
          {" "}
                    {t("shortMinutes")}{" "}
        </span>
            </Form.Item>

            <Form.Item
                labelAlign="left"
                label="Минимальная частота данных"
                rules={[{required: false, message: "Введите интервал"}]}
            >
                <Form.Item initialValue={warningData?.minDataFrequency.minute}
                           noStyle
                           name={["trendSettingsCommon", "minDataFrequencyMinutes"]}
                           rules={[{required: false, message: "Введите минуты интервала"}]}
                >
                    <InputNumber
                        min={0}
                        max={999}
                        style={{
                            width: "30%",
                        }}
                    />
                </Form.Item>

                <span className="ant-form-text" style={{paddingLeft: "5px"}}>
          {" "}
                    {t("shortMinutes")}{" "}
        </span>
            </Form.Item>

            <Form.Item
                labelAlign="left"
                label="Минимальный период"
                rules={[{required: false, message: "Введите интервал"}]}
            >
                <Form.Item initialValue={warningData?.analysisPeriodMin.day}
                           noStyle
                           name={["trendSettingsCommon", "analysisPeriodMinDays"]}
                           rules={[{required: false, message: "Введите сутки интервала"}]}
                >
                    <InputNumber
                        min={0}
                        max={365}
                        style={{
                            width: "30%",
                        }}
                    />
                </Form.Item>

                <span className="ant-form-text" style={{paddingLeft: "5px"}}>
          {" "}
                    {t("shortDays")}{" "}
        </span>
                <Form.Item initialValue={warningData?.analysisPeriodMin.hour}
                           noStyle
                           name={["trendSettingsCommon", "analysisPeriodMinHours"]}
                           rules={[{required: false, message: "Введите часы интервала"}]}
                >
                    <InputNumber
                        min={0}
                        max={23}
                        style={{
                            width: "30%",
                        }}
                    />
                </Form.Item>
                <span className="ant-form-text" style={{paddingLeft: "5px"}}>
          {" "}
                    {t("shortHours")}{" "}
        </span>
            </Form.Item>

            <Form.Item
                labelAlign="left"
                label="Максимальный период"
                rules={[{required: false, message: "Введите интервал"}]}
            >
                <Form.Item initialValue={warningData?.analysisPeriodMax.day}
                           noStyle
                           name={["trendSettingsCommon", "analysisPeriodMaxDays"]}
                           rules={[{required: false, message: "Введите сутки интервала"}]}
                >
                    <InputNumber
                        min={0}
                        max={365}
                        style={{
                            width: "30%",
                        }}
                    />
                </Form.Item>

                <span className="ant-form-text" style={{paddingLeft: "5px"}}>
          {" "}
                    {t("shortDays")}{" "}
        </span>
                <Form.Item initialValue={warningData?.analysisPeriodMax.hour}
                           noStyle
                           name={["trendSettingsCommon", "analysisPeriodMaxHours"]}
                           rules={[{required: false, message: "Введите часы интервала"}]}
                >
                    <InputNumber
                        min={0}
                        max={23}
                        style={{
                            width: "30%",
                        }}
                    />
                </Form.Item>
                <span className="ant-form-text" style={{paddingLeft: "5px"}}>
          {" "}
                    {t("shortHours")}{" "}
        </span>
            </Form.Item>

            <Form.Item
                labelAlign="left"
                label="Дискретность анализа"
                rules={[{required: false, message: "Введите интервал"}]}
            >
                <Form.Item initialValue={warningData?.timeDiscr.day}
                           noStyle
                           name={["trendSettingsCommon", "timeDiscrDays"]}
                           rules={[{required: false, message: "Введите сутки интервала"}]}
                >
                    <InputNumber
                        min={0}
                        max={365}
                        style={{
                            width: "30%",
                        }}
                    />
                </Form.Item>

                <span className="ant-form-text" style={{paddingLeft: "5px"}}>
          {" "}
                    {t("shortDays")}{" "}
        </span>
                <Form.Item initialValue={warningData?.timeDiscr.hour}
                           noStyle
                           name={["trendSettingsCommon", "timeDiscrHours"]}
                           rules={[{required: false, message: "Введите часы интервала"}]}
                >
                    <InputNumber
                        min={0}
                        max={23}
                        style={{
                            width: "30%",
                        }}
                    />
                </Form.Item>
                <span className="ant-form-text" style={{paddingLeft: "5px"}}>
          {" "}
                    {t("shortHours")}{" "}
        </span>
            </Form.Item>

            <div style={{paddingLeft: "20px"}}>
                <Collapse accordion ghost>
                    {warningData?.trendConstraints.map(trendConstraint => (
                        <Panel key={trendConstraint.parameterId}
                               header={
                                   <div
                                       style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <span>{`Предупреждение параметр = ${chooseTranslateFromArray(
                      trendConstraint.parameterId,
                      storageTranslations,
                      currentLanguage
                  )}`}</span>
                                       {Boolean(accessStore.checkPermission("add_and_del_trend_analysis_settings")) &&
                                           <Space>
                                               <Popconfirm
                                                   title={t("areYouSureToDeleteParameter")}
                                                   okText={t("apply")}
                                                   cancelText={t("cancel")}
                                                   onConfirm={() => handleDeleteConstraint(trendConstraint.id, warningData?.trendGroupName, trendConstraint.parameterId)}
                                                   placement="left"
                                               >
                                                   <Typography.Link>
                                                       <DeleteOutlined/>
                                                   </Typography.Link>
                                               </Popconfirm>
                                           </Space>
                                       }
                                   </div>
                               }
                        >
                            <TrendConstraintApprox
                                approxConstraintsFirst={trendConstraint.approxConstraintsFirst}
                                approxConstraintsLast={trendConstraint.approxConstraintsLast}
                                constraintId={trendConstraint.parameterId}
                                settingsType={"trendSettingsCommon"}
                            />
                        </Panel>))}

                </Collapse>
            </div>
            <Form.Item wrapperCol={{...layout.wrapperCol, offset: 10}}>
                <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                        backgroundColor: buttonText === t("apply") ? "" : "lightseagreen",
                    }}
                >
                    {buttonText}
                </Button>
            </Form.Item>
        </Form>
    );
});

export default TrendSettings;
